export interface Props {
    value: boolean
    onChange: (value: boolean) => void
}

export default function ToggleSwitch3({
    value,
    onChange,
}: Props): React.JSX.Element {
    const getPillColor = () => {
        return value ? 'bg-ctxt-blue' : 'bg-gray-300'
    }

    const getContainerBg = () => {
        return value ? 'bg-ctxt-blue/10' : 'bg-gray-100'
    }

    const index = value ? 1 : 0

    const handleClick = () => {
        onChange(!value)
    }

    return (
        <div
            onClick={handleClick}
            className={`relative flex rounded-full w-[32px] h-4 overflow-hidden transition-colors duration-300 cursor-pointer ${getContainerBg()}`}
        >
            {/* Background pill */}
            <div
                className={`absolute inset-y-0 left-0 w-1/2 rounded-full transition-all duration-300 ${getPillColor()}`}
                style={{ left: `${index * 50}%` }}
            />
        </div>
    )
}
